__turbopack_context__.v({
  "bounceIn": "b31S7a_bounceIn",
  "fadeInScale": "b31S7a_fadeInScale",
  "fadeInStagger1": "b31S7a_fadeInStagger1",
  "fadeInStagger2": "b31S7a_fadeInStagger2",
  "fadeInUp": "b31S7a_fadeInUp",
  "slide": "b31S7a_slide",
  "stripe": "b31S7a_stripe",
  "subtlePulse": "b31S7a_subtlePulse",
});
